import type { Card } from './SelectList.types';

export const isCardSelect = (card: Card, selectedCardsId: { id: string | number }[]) => {
	if (selectedCardsId?.length > 0) {
		return selectedCardsId.find((c) => c.id == card.id) !== undefined;
	}

	return card.selected || false;
};
